// extracted by mini-css-extract-plugin
module.exports = {"switch_container":"SwitchWithLabel_switch_container__2izI2","switch_text":"SwitchWithLabel_switch_text__1eknE"};